import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    interval: Number,
    url: String,
  }

  connect() {
    this.timeout = setTimeout(() => this.refresh(), this.intervalValue * 1000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  refresh() {
    const url = this.urlValue || window.location.href
    const frame = this.element.closest('turbo-frame')

    if (!frame) return window.Turbo.visit(url)

    // an overlay leaves the page URL on the screen behind it, so the frame is what reloads;
    // clearing src first makes Turbo fetch again even when it already points here
    frame.removeAttribute('src')
    frame.setAttribute('src', url)
  }
}
